const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Play+Quiz+Details


function getPlayQuizDetails(profileId, type) {
    const url = `/api/users/profiles/${profileId}/quiz?type=${type}`;
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = getPlayQuizDetails;
